import styled from "styled-components";

export const StyledSelect = styled.div`
  .custom-creatable {
    &__control {
      cursor: pointer;
      border: none;
      border-radius: 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.42);
      &:hover {
        border-color: #162954;
        box-shadow: 0 1px 0 0 #162954;
      }
    }
    &__control--is-focused {
      border-bottom: 1px solid #162954;
      box-shadow: 0 1px 0 0 #162954;
    }
    &__value-container {
      padding: 0;
      grid-template-columns: 100%;
    }
    &__indicator-separator {
      display: none;
    }
    &__dropdown-indicator {
      width: 20px;
      position: relative;
      &:before {
        content: '\\e935';
        color: #7d7d7d;
        font-size: 18px;
        font-family: 'cp-icons', serif;
        position: absolute;
        top: 0;
        left: 0;
      }
     svg {
        display: none;
      }
    }
    &__input-container {
      padding: 0;
    }
    &__input {
      height: 25px !important;
      min-width: 300px !important;
      z-index: 1 !important;
    }
  }
`;

export const StyledSelectLabel = styled.label`
  color: #7e7e7e;
  font-size: 12px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  transform: translate(0, 1.5px) scale(0.75);
  transform-origin: top left;
`;